export const stripFileExtension = (fileName: string) => {
  return fileName.replace(/\.[A-Za-z0-9]+$/, '');
};
